import clone from 'lodash/cloneDeep';
import initialState from '../../../store/initialState';
import {
  ADD_BUTT_JOINT_CONNECTION_STARTING,
  ADD_BUTT_JOINT_CONNECTION_SUCCESS,
  ADD_BUTT_JOINT_CONNECTION_ERROR,
} from '../../../constants/actionTypes';

export default function addButtJointReducer(state = initialState.addButtJoint, action) {
  switch (action.type) {
    case ADD_BUTT_JOINT_CONNECTION_STARTING: {
      const newState = clone(state);
      newState.saving = true;
      newState.saved = false;
      return newState;
    }

    case ADD_BUTT_JOINT_CONNECTION_SUCCESS: {
      const { data } = action;

      const newState = clone(state);
      newState.saving = false;
      newState.saved = true;
      newState.error = null;

      newState.newButtJoint = data.buttJoint;
      return newState;
    }

    case ADD_BUTT_JOINT_CONNECTION_ERROR: {
      const newState = clone(state);
      newState.saving = false;
      newState.saved = false;
      newState.error = action.err;
      return newState;
    }

    default: {
      return state;
    }
  }
}
